<template>
<!-- 应急处置列表 -->
  <div class="log-box">
    <div class="box-head">
      <div style="display:flex;width:80%;align-content: center;align-items: center;">
        <!-- <span>更新端：</span>
        <el-select v-model="search.useType" clearable placeholder="请选择">
            <el-option
            v-for="item in userTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
         - 
        <el-select v-model="search.type" clearable placeholder="请选择">
            <el-option
            v-for="item in portList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
        <span style="margin-left:1vw;">更新人员：</span>
        <el-input v-model="search.createBy" placeholder="请输入" style="width:12vw;"></el-input>
        <el-button type="primary" style="margin-left:1vw;" @click="doFilter">查询</el-button> -->
      </div>
      <el-button type="primary" @click="addLog">添加</el-button>
    </div>
    <div class="box-main">
      <el-table
        :data="listData"
        height="100%"
        border
        style="width: 100%;"
      >
        <template slot="empty">
          <p>{{dataText}}</p>
        </template>
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            <a>{{ ((currentPage - 1) * pageSize)+(scope.$index+1) }}</a>
          </template>
        </el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">
            <a>{{getTypeName(scope.row.type)}} </a>
          </template>
        </el-table-column>
        <el-table-column label="使用物资" width="600">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.proEmergencyProcessingDetails" :key="index" style="margin-bottom: 1vh;">
                <span>物资：{{item.suppliesName}}</span>
                <span style="margin-left:1vw;">数量：{{item.count}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="应急内容">
          <template slot-scope="scope">
            <span>{{ scope.row.content }}</span>
          </template>
        </el-table-column>
        <el-table-column label="时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createDate }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作">
            <template slot-scope="scope">
                <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
                <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
        </el-table-column> -->
      </el-table>
      <!-- 表单列表 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import myHttp from '../../../untils/port';
import util from '../../../untils/util';
export default {
  data(){
    return{
      search:{
        date:'',
        type:'',
        createBy:'',
        useType:''
      },
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      listData:[//数据列表
        // {id:'1',type:'1',typeName:'环境',contain:'大雨来袭，使用应急雨衣。',mate:[{id:"1",name:'雨衣',num:'5'}],createTime:'2021-07-08'}
      ],
      dataText:'数据加载中...',//提示
      // portList:[],//
      // userTypeList:[],//平台端
      typeList:[],
    }
  },
  mounted(){
    this.getType()
    // this.getUserType()
    this.getData()
  },
  methods:{
    //获取平台端
    // getUserType(){
    //   var that = this
    //   myHttp.getDictByType({
    //       type:'user_type'
    //   }).then(function(resp){
    //       if(resp.data.code=='200'){
    //           var list = resp.data.data.dictList||[]
    //           that.userTypeList = list
    //       }else{
    //           that.$message.error(resp.data.msg)
    //       }
          
    //   })
    // },
    //获取更新端
    getType(){
      var that = this
      myHttp.getDictByType({
          type:'handler_type'
      }).then(function(resp){
          if(resp.data.code=='200'){
              var list = resp.data.data.dictList||[]
              that.typeList = list
          }else{
              that.$message.error(resp.data.msg)
          }
          
      })
    },
    getTypeName(id){
      var result = ''
      for(var i=0;i<this.typeList.length;i++){
        if(id == this.typeList[i].value){
          result = this.typeList[i].label
        }
      }
      return result
    },
    // 搜索数据
    doFilter() {
      this.currentPage = 1
      this.getData();
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentChangePage()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.currentChangePage();
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData();
    },
    //获取数据
    getData(){
      var that = this
    //   this.dataText = '暂无数据'
      this.search.pageNum = this.currentPage
      this.search.pageSize = this.pageSize
      myHttp.selectProEmergencyProcessingPage(this.search).then(function(resp){
          if(resp.data.code=='200'){
              var list = resp.data.data.pageInfo.list||[]
              that.listData = list
              that.totalItems = resp.data.data.pageInfo.total||0
              if(list.length==0){
                  that.dataText = '暂无数据'
              }
          }else{
              that.dataText = '暂无数据'
          }
      })
    },

    //修改
    handleEdit(index,row){
        this.$router.push({path:'/emerHardAdd/'+row.id})
    },

    //进入添加页面
    addLog(){
      this.$router.push({path:'/emerHardAdd/0'})
    },

    //删除
    handleDelete(index,row){
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.deleteSysSystemUpdateLog({
            id: row.id
        }).then(function(resp) {
            if (resp.data.code == '200') {
              that.$message.success('删除成功')
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
        })
      }).catch(() => {
        
      })
    },
  }
}
</script>

<style scoped>
  .log-box{
    width: 100%;
    height: 100%;
    position: relative;
  }
  .box-head{
    width: 100%;
    height: 7vh;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    padding: 0 1vw;
    background: #fff;
    border-bottom: 2px solid #409EFF;
    justify-content: space-between;
  }
  .box-main{
    width: 100%;
    height: calc( 100% - 12vh );
    position: relative;
    background: #fff;
  }
</style>

<style>
  .el-pagination{
    width: 100%;
    height: 5vh;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    justify-items: center;
    background: #fff;
  }
</style>